<div class="mobile-app">
  <!-- Header móvil -->
  @if (showHeader()) {
    <app-header></app-header>
  }

  <!-- Contenido principal -->
  <main class="mobile-content">
    <router-outlet />
  </main>

  <!-- Overlay de carga (logo con pulse) para peticiones API -->
  <app-loading-overlay />
</div>

